import "@arcgis/map-components/components/arcgis-line-of-sight";

function ViewAnalyse() {
  return (
    <>
      <arcgis-line-of-sight referenceElement="viewDiv"></arcgis-line-of-sight>
    </>
  );
}

export default ViewAnalyse;
